var exports = {
  "s": "sidebarContainer__wl6jUR",
};

module.exports = exports;
